/* global Text, MyFacture, Dashboard, TokenInput, Symbol, Loc, MyWindow, MyForm */

window.Annotation = {
	
	init : function(id){
		var relatedtype = $('#'+ id + " .annotations-container input[name='relatedtype']").val();
		var relatedid	= $('#'+ id + " .annotations-container input[name='relatedid']").val();
		var linkedtype	= $('#'+ id + " .annotations-container input[name='linkedtype']").val();
		var linkedid	= $('#'+ id + " .annotations-container input[name='linkedid']").val();
		var indexLimit	= $('#'+ id + " .annotations-container input[name='indexLimit']").val();
		var annotid		= $('#'+ id + " .annotations-container input[name='annotid']").val();

		if(indexLimit > 0){
			$('#'+ id + " .annotations-container input[name='indexLimit']").attr('value', 0);
		}

		Annotation.moreAnnotation(id, relatedtype, relatedid, linkedtype, linkedid, annotid);
		Annotation.prepareMainForm(id, relatedtype, relatedid);
		Annotation.prepareReplyForms(id);
		Annotation.bindElements(id, relatedtype, relatedid, linkedtype, linkedid);
		Annotation.refreshContainer(id);
		
		$.mask.definitions['5']='[0-5]';
		var formatMask = ($(".annot_ttnbSecondes").hasClass('hasSeconds')) ? "99:59:59" : "99:59";
		$(".annot_ttnbSecondes").mask(formatMask, {placeholder:"-", replacement : '0'});
		
	},
			
	refreshContainer : function(id){
		
		if ($('#dashboard').length !== 0) return;
		
		var nbAnnotation = $('#'+ id + ' .annotationsList li').length;
		if (nbAnnotation === 0) {
			$('#'+ id).height(145);
		} else {
			$('#'+ id).height(450);
		}
	},

	bindElements: function(id, relatedtype, relatedid, linkedtype, linkedid){

		$('#' + id ).on('focus', ' .annotationsFormContainerMain textarea', function(){
			$(this).closest('.annotationFormContainer').removeClass('annotationsFormContainerMain');
			Annotation.initResizeTextarea($(this), true);
		});
			
		$('.moreBtn').off().on('click', '#'+ id+' a', function(){
			Annotation.moreAnnotation(id, relatedtype, relatedid, linkedtype, linkedid);
		});
		
	},
			
	cancelMainAnnotationAdd: function(me){
		var annotationFormContainer = me.closest('.annotationFormContainer');
		annotationFormContainer.addClass('annotationsFormContainerMain').find('textarea').val("").removeAttr('style');
	},
	
	switchCategory: function(category, linkedtype){

		var hideAddComment = false;
		if (linkedtype == "client" || linkedtype == "supplier" || linkedtype == "prospect"){
			linkedtype = 'third';
			if(category !== 'third'){
				hideAddComment = true;
			}
		}

		var annotationForm = $('#third_mainAnnotation').closest('.annotationFormContainer');

		if(linkedtype == 'dashboard'){
			annotationForm = $('#comments #dashboard_mainAnnotation');
			hideAddComment = category !== 'dashboard';
		}

		if(hideAddComment){
			annotationForm.hide();
		} else{
			annotationForm.show();
		}

		var annotTitle = $("#annotations-categories li[annotype='"+category+"']").attr('tips');
		$('.annotTitleToSwitch').html(annotTitle);
		
		$('.comments-breadcrumd').html(' > ' + annotTitle);

		$('#annotations-categories .selected-category').removeClass('selected-category');
		$('#annotations-categories li[annotype="'+category+'"]').addClass('selected-category');
		$('input:hidden[name=indexLimit]').val(0);
		$('#comments .annotationsList').html("");

		var method = (category === linkedtype) ? "show" : "hide";
		$('#comments #'+linkedtype+'_mainAnnotation')[method];

		$('#comments .annotations-container input[name="relatedtype"]').val(category);
		Annotation.init('comments');
		
	},
	
	prepareMainForm : function(id, relatedtype, relatedid){
		
		var formid = relatedtype +"_mainAnnotation";

		var options = {
			success: function(data){
				Annotation.addAnnotationCallBack(id, data);
			},
			dataType:"json"};

		var params = {'action': 'addAnnotation'};

		MyForm.prepare(formid, "annotations&"+$.param(params), options);
		MyFacture.initEvent();
		
	},
	
	prepareReplyForms : function(id){
		
		$('#'+id+' .replyAnnotation').each(function(){
			var formId	= id + " #" + $(this).attr('id');

			var options	= {
				success: function(data){
					Annotation.addAnnotationCallBack(id, data);
				},
				dataType:"json"};

			var params	= {'action': 'addAnnotation'};

			MyForm.prepare(formId, "annotations&"+$.param(params), options);
		});
	},
	
	addAnnotationCallBack : function(id, data){
		var annot		= data.annotations;
		var annotHTML	= '';
		var regExp		= new RegExp('EVENT_ID', 'g');
		var formIsOk	= MyForm.processJson(data, 'mainAnnotation');
		
		if(!formIsOk){
			return false;
		}
		
		$('#'+ id + " form").find('.annotationFormContainer').hide();
		
		if(annot.parentid == '0'){
			$('#'+ id + '.annotationsList').prepend(annotHTML);
			
			// clean
			var form = $('#'+ id + " .annotations-main-form");
			form.find('textarea').val('');
			
			// add
			annotHTML = $('#annotation_template').html();
			annotHTML = annotHTML.replace(regExp, parseInt(annot.id,10));
			
			$('#'+ id + ' .annotationsList').prepend(annotHTML);	
			form.closest('.annotationsGroup').find('.annotForm').hide();
			form.closest('.annotationFormContainer').addClass('annotationsFormContainerMain').find('textarea').removeAttr('style');
			Annotation.init();
			
		} else {
			annotHTML = $('#subAnnotation_template').html();
			annotHTML = annotHTML.replace(regExp, parseInt(annot.id, 10));
			$('#'+ id + ' #annotation_'+annot.parentid).find('ul').not('.token-input-list').append(annotHTML);
			$('#'+ id + ' #annotation_'+annot.parentid).find('.replyAnnotation textarea').val('');
			
			$('#'+ id + ' #annotation_'+annot.parentid).find('.replyAnnotaiton').addClass('annotationsFormContainerMain').find('textarea').removeAttr('style');
		}
		
		var myAnnot = $('#'+ id + ' #annotation_'+annot.id);
		var text	= Text.stripslashes(annot.annotation);
		var title	= Text.stripslashes(annot.title);
		var icon	= Text.stripslashes(annot.icon);
		var date	= Text.stripslashes(annot.date);
		
		myAnnot.find('#annot_id').val(annot.id);
		myAnnot.find('.title').html(title);
		
		
		myAnnot.find('.icon').html(icon);
		myAnnot.find('.textAnnot').html(text);
		myAnnot.find('.time').html(date);
		myAnnot.find('#annot_relatedtype').val(annot.relatedtype);
		myAnnot.find('#annot_relatedid').val(annot.relatedid);
		myAnnot.find('#annot_parentid').val(annot.parentid);
		myAnnot.attr('auto_mousehover', 'true');
		myAnnot.find('.rightClickOption').val(annot.rightClick);
		myAnnot.find('#annotationForm_'+annot.id+' textarea').html(annot.annotationRaw);

		$('#'+ id + ' .annotations-container .noEvent').hide();
		
		Annotation.prepareReplyForms(id);
		MyFacture.initEvent();
		MyFacture.customForm();
		
		if (annot.timetracking){

			// On clear le contenu des éléments de time tracking
			var initTT = ($('#annot_tt_nbSecondes').hasClass('hasSeconds')) ? '00:00:00' : '00:00';
			$('#annot_tt_nbSecondes').val(initTT);

			myAnnot.find('.ttAnnotation').html(annot.formatted_timetracking);
			myAnnot.find('.annot_ttnbSecondes').val(annot.timetracking.time);
			
			TokenInput.autoItem(myAnnot.find('.annot_ttService'), 'service', 'timetrackingEnabled', 1);
			myAnnot.find('.annot_ttService').tokenInput('clear');
			myAnnot.find('.annot_ttService').tokenInput("add", {id: 'item_' + annot.timetracking.serviceid, name: annot.timetracking.service});
		
		}

		Annotation.updateTabCount();
		
	},

	updateTabCount : function(){
		var count = $('.annotationsList .annotationsGroup').length;
		$('#commentsevents .notif').toggleClass('hidden', count == 0).html(count);
	},

    editAnnotation: function(eventid) {

		var form = $('#annotationForm_' + eventid);

		$.mask.definitions['5']='[0-5]';
		var formatMask = ($(".annot_ttnbSecondes").hasClass('hasSeconds')) ? "99:59:59" : "99:59";
		form.find(".annot_ttnbSecondes").mask(formatMask, {placeholder:"-", replacement : '0'});

		$(form).show();
		

		var textarea = $(form).find('textarea');

		textarea.attr('disabled', false);
		MyFacture.customForm($(form));
		Annotation.prepareEditForm($(form).attr('id'));
		textarea.focus();

		if(form.find(".token-input-list").length == 0){
			TokenInput.autoItem(form.find('.annot_ttService'), 'service', 'timetrackingEnabled', 1);
		}

		Annotation.initResizeTextarea(textarea, true);

    },

	initResizeTextarea: function(textarea, firstInit){

		// TEXTAREA RESIZING PART
		var offset = textarea.prop('offsetHeight') - textarea.prop('clientHeight');

		// DEFINE RESIZING FUNCTION
		var resizeTextarea = function(field) {
			field.css('height', 'auto').css('height', field.prop('scrollHeight') + offset);
		};

		// DEFAULT VALUE = TRUE
		if(firstInit == undefined || firstInit !== false){
			firstInit = true;
		}

		// FIRST RESIZING OF THE TEXTAREA
		if(firstInit){
			resizeTextarea(textarea);
		}

		// RESIZING ON KEYUP AND INPUT (for copy/past)
		textarea.on('keyup, input', function() {
			resizeTextarea(textarea);
		});

	},
	
	cancelEditAnnotation: function(eventid){
		
		var form = $('#annotationForm_' + eventid);
		
		$(form).hide();
		$(form).parent().parent().find('.textAnnot').show();
		$(form).find('textarea').attr('disabled', true).removeAttr('style');
		
    },
	
	prepareEditForm: function(formId){
		
		var options = {
			success:function(data){
				if(data.error == 'Y'){
					MyWindow.alert(Loc.g("Un des champs n'est pas renseigné."),
						{
						type:'error'
					});
				} else{
					Annotation.recordEditCallback(data);
				}
		}, dataType:"json"};
		var params = {'action': 'updateAnnotation'};
		MyForm.prepare(formId, "annotations&"+$.param(params), options);
		MyFacture.initEvent();
		
	},
	
	recordEditCallback: function(data){
		
		var formIsOk = MyForm.processJson(data, "");
		if (formIsOk){
			
			var $form				= $('#annotationForm_' + data.annotid);
			var $formContainer		= $form.parent().parent();
			var $annotForDisplaying	= $formContainer.find('.textAnnot');
			
			$annotForDisplaying.html(Text.stripslashes(data.text));
			$form.find('textarea').html(data.textRaw);
			
			if (data.event.formatted_timetracking){
				$formContainer.find('.ttAnnotation').html(data.event.formatted_timetracking);
			}
			
			$annotForDisplaying.show();
			
			$form.hide();
			$('#annotationForm_'+data.annotid).find('.editConfirmButton').css('display', 'none');

		}

	},

  	confirmDelete : function(annotid, hasTimeTrakcing){
		
		var popupWidth = 300;
		
		var buttonsSet = [];
		
		buttonsSet.push({text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}});
		
		buttonsSet.push({
			text : Loc.g("Supprimer"), 
			'class': "btn btn-primary",
			click : function(){
				Annotation.deleteAnnotation(annotid);
				$(this).dialog("close");
			}
		});
		
		if (hasTimeTrakcing == "Y"){
			buttonsSet.push({
				text : Loc.g("Supprimer avec le timetracking"),
				'class': "btn btn-primary",
				click : function(){
				Annotation.deleteAnnotation(annotid, "Y");
				$(this).dialog("close");
				}
			});
			popupWidth = 450;
		}

		MyWindow.alert(Loc.g("Supprimer le commentaire ?"),
		{
			width: popupWidth,
			type:'warning',
			buttons:buttonsSet
		} 
		);

		if ($('.btn-task__modifier').hasClass('btn-default')){
			$('.btn-task__modifier').removeClass('btn-default');
		}
		
	},
	
	deleteAnnotation: function(eventId, deleteTimetracking){
		
		var deleteTimetracking = deleteTimetracking === undefined ? "N" : deleteTimetracking;
 		
		MyFacture.post('annotations', {annot_id:eventId, action:'delete', deleteTimetracking:deleteTimetracking}, function(data){
			if (data.retour === true){
				$('#annotation_'+eventId).fadeOut('slow', function(){$(this).remove(); Annotation.updateTabCount();});
			}else{
				$('#annotation_'+eventId).find('.actionDelete').fadeOut();
			}
		}, 'json' );

	},
	
	moreAnnotation : function(id, relatedType, realatedId, linkedtype, linkedid, annotid) {
		
		var moreBtn = $('#'+ id + ' .moreBtn a');
		$('#'+ id + ' .nano').addClass('beLoading');
		
		if (!moreBtn.hasClass('stop')){
			
			if ((linkedtype == "client" || linkedtype == "prospect" || linkedtype == "supplier") && relatedType != 'third'){
				realatedId = 0;
			}
			
			var params = {
				action		: 'moreAnnotation',
				indexLimit	: $('#'+ id + ' input:hidden[name=indexLimit]').val(),
				relatedid	: realatedId,
				relatedtype : relatedType,
				linkedtype	: linkedtype,
				linkedid	: linkedid,
				annotid		: annotid
			};

			moreBtn.addClass('stop');
			MyFacture.beLoading(moreBtn);

			MyFacture.post('annotations', params, function(data){
				$('#'+ id + ' .moreBtn').remove();
				$('#'+ id + ' .beLoading').removeClass('beLoading');
				$('#'+ id + ' input:hidden[name=indexLimit]').attr('value', data.indexLimit);
				$('#'+ id + ' .annotationsList').append(data.annotations);
				MyFacture.customForm($('#'+ id + ' .annotationsList'));
				Annotation.prepareReplyForms(id);
				$('#'+ id + ' .nano').nanoScroller({preventPageScrolling: true});
				
				Annotation.refreshContainer(id);
				
				if(data.commentTabIsEmpty) {
					moreBtn.hide();
				}

				moreBtn.removeClass('stop');
		
				$('[id^=annotationInput_][data-resizable=true]:not(#annotationInput_EVENT_ID)').each(function(i, e) {
					Annotation.initResizeTextarea($(e), false);
				});

			}, 'json' );
			
		}
		
	},

	preview: function(id) {
		var self     = this;
        var settings = {
            class: 'annotations',
			width: 'small',
            callback: function(data) {


				// var buttonDelete = {
				// 	name	: self.translations.deleteButton,
				// 	id		: 'btnDeleteDetailEvent',
				// 	action	: function() {
				// 		if(isEventRecurring == "Y"){
				// 			Agenda.checkDeleteRecurring(eventId, calendarId, 'event', $('#tsStartRecurringEvent').val(), title);
				// 		} else {
				// 			Agenda.deleteAlert(eventId, calendarId, false, 'N', 'event', '', '', title);
				// 		}
				// 		Panel.prototype.close();
				// 	}
				// };
				// Panel.prototype.addButton(buttonDelete);
				
				// //Bouton modifier
				// var buttonModify = {
				// 	name	 : self.translations.modifyButton,
				// 	class	 : 'btn-primary',
				// 	id		 : 'btnModifyDetailEvent',
				// 	action	 : function() {
				// 		Agenda.editForm(eventId, calendarId, undefined, undefined, undefined, 'event', undefined, undefined, isEventRecurring, startDate, endDate, title);
				// 		Panel.prototype.close();
				// 	}
				// };
				// Panel.prototype.addButton(buttonModify, 'right');
				
				Panel.prototype.setTitle("Commentaire");

				Annotation.init("cardComments");
                
                // Init Qtip();
                Qtip.init();
            },
            beforeClose: function(event, ui) {
                // Clean all current XHR
                MyFacture.cleanQueue();
            }
        };
        var panel  = new Panel(settings);
        var params = {
            action		: 'previewAnnotation',
            id		: id,
			// calendarId	: calendarId,
			// startDate	: startDate,
			// endDate		: endDate,
        };
		
        panel.open('annotations', params);
	},

	// editAnnotations : function(contexte, eventId, calendarId) {
		
	// 	var buttons = [];
	// 	buttons.push({
	// 		text : Loc.g("Fermer"),
	// 		'class' : 'btn btn-gray',
	// 		click : function(){
	// 			$(this).dialog("close");
	// 			Agenda.refreshAgenda();
	// 		}
	// 	});
		
	// 	var options = {
	// 		title	: "Commentaires",
	// 		buttons	: buttons,
	// 		width : 600,
	// 		callback	: function(){
	// 			Annotation.init("cardComments");
	// 		}
	// 	};

	// 	MyWindow.load(
	// 		"agenda", 
	// 		{
	// 			action		: "editAnnotations",
	// 			eventId		: eventId,
	// 			calendarId	: calendarId
	// 		}, 
	// 		options
	// 	);
	// },

};

window.CommentsTab = {

    loadCommentsTab: function (linkedtype, linkedid, editpermission) {

        $('#content_commentsevents').html(MyWindow.getLoader());
        
        var options = {
            action: "loadCommentsTab",
            linkedid: linkedid,
            linkedtype: linkedtype,
            editpermission: editpermission,
        };

        MyFacture.post('annotations', options, function (data) {
            $('#content_commentsevents').html(data.listing);
			Annotation.init('comments');
			Qtip.init();
        }, 'json');
    }
};
